import React from 'react';
import AppHeader from '../../common/app-header/AppHeader';
import DocumentVaultBlock from './DocumentVaultBlock';
import { useTranslation } from 'react-i18next';

const DocumentsKeyDates = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* The Key Dates overview moved to the aside ("How Key Dates work"). */}
      <AppHeader title={t('headers.keyDates')} />
      <DocumentVaultBlock />
    </>
  );
};

export default DocumentsKeyDates;
